import { render } from "./DetailsExtras.vue?vue&type=template&id=e3c65e7c&scoped=true"
import script from "./DetailsExtras.vue?vue&type=script&lang=js"
export * from "./DetailsExtras.vue?vue&type=script&lang=js"

import "./DetailsExtras.vue?vue&type=style&index=0&id=e3c65e7c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c65e7c"]])

export default __exports__